export default __webpack_public_path__ + "static/logo-skolekino-sort-ab3c63160e3455693f95f3fa4b0625a6.png";